import { isNil } from 'ramda';
export const parseJson = (value) => {
    if (isNil(value)) {
        return undefined;
    }
    try {
        return JSON.parse(value);
    }
    catch (_error) {
        return undefined;
    }
};
//# sourceMappingURL=parseJson.js.map